import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Component } from '@angular/core';

import { AppService } from '../../services/app.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ILessonObservation } from '../../models/LessonObservation';
import { LessonObservationApprovalComponent } from './approval.component';

@Component({
    selector: 'app-lesson-observation-view',
    templateUrl: './view.component.html'
})
export class LessonObservationViewComponent implements OnInit {
    constructor(
        private app: AppService,
        private modal: NgbModal
    ) { }

    @Input() data: ILessonObservation;

    @Output('edit') editEvent = new EventEmitter();

    canEdit: boolean;
    canPromote: boolean;
    canReview: boolean;

    get goalsDisplay() {
        return this.data.Goals.map(t => t.Value).join(', ');
    }

    ngOnInit() {
        this.canEdit = (this.data.Status == 'Draft' || this.data.Status == 'Submitted') && this.app.currentUser.hasRight('LESSON_OBSERVATION.EDIT');
        this.canPromote = this.data.Status == 'Submitted' && this.app.currentUser.hasRight('LESSON_OBSERVATION.PROMOTE');
        this.canReview = this.data.Status == 'Promoted' && this.app.currentUser.hasRight('LESSON_OBSERVATION.APPROVE');
    }

    getRoleDisplay(roles: { Value: string }[], otherRole?: string): string {
        return roles.map(t => t.Value).join(', ') + (otherRole ? ` (${otherRole})` : '');
    }

    review() {
        const ref = this.modal.open(LessonObservationApprovalComponent);
        ref.componentInstance.data = this.data;
        ref.componentInstance.type = 'review';
        ref.result.then(() => {
            this.app.navigate(['/lesson-observations']);
        }, () => { });
    }

    promote() {
        const ref = this.modal.open(LessonObservationApprovalComponent);
        ref.componentInstance.data = this.data;
        ref.componentInstance.type = 'promotion';
        ref.result.then(() => {
            this.app.navigate(['/lesson-observations']);
        }, () => { });
    }

    edit() {
        this.editEvent.emit();
    }
}
